// extracted by mini-css-extract-plugin
export default {"layout":"dc904913d5 d3589a4cd8 _0b4767971c","h_slide":"_6922803c09","category":"_695031b2d1 _5e7c01afe6 _25f29d8134"};